import { render, staticRenderFns } from "./inspectionRecords.vue?vue&type=template&id=74e66950&scoped=true&"
import script from "./inspectionRecords.vue?vue&type=script&lang=js&"
export * from "./inspectionRecords.vue?vue&type=script&lang=js&"
import style0 from "./inspectionRecords.vue?vue&type=style&index=0&id=74e66950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74e66950",
  null
  
)

export default component.exports